import { useState } from 'react';
import { supabase } from '../lib/supabase';

export function useAvatar() {
  const [uploading, setUploading] = useState(false);

  async function uploadAvatar(userId, file) {
    setUploading(true);
    try {
      const ext = file.name.split('.').pop();
      const path = `${userId}/avatar.${ext}`;
      const { error } = await supabase.storage
        .from('avatars')
        .upload(path, file, { upsert: true, contentType: file.type });
      if (error) throw error;
      const { data } = supabase.storage.from('avatars').getPublicUrl(path);
      return data.publicUrl + '?t=' + Date.now();
    } finally {
      setUploading(false);
    }
  }

  async function getAvatarUrl(userId) {
    const exts = ['jpg', 'jpeg', 'png', 'webp'];
    for (const ext of exts) {
      const { data } = supabase.storage.from('avatars').getPublicUrl(`${userId}/avatar.${ext}`);
      if (data?.publicUrl) {
        try {
          const res = await fetch(data.publicUrl, { method: 'HEAD' });
          if (res.ok) return data.publicUrl;
        } catch {}
      }
    }
    return null;
  }

  return { uploadAvatar, getAvatarUrl, uploading };
}
